/** Practice dashboard staff list tables (Admin, Provider, Caregiver, System Caregiver). */
export const STAFF_LIST_TABLE_CARD = 'practice-tab-table-card practice-tab-table-card--staff-list';

/** Shared colgroup widths — keeps # / Status / Name / etc. aligned when switching tabs. */
export const STAFF_LIST_WIDTHS = {
  idx: '56px',
  status: '96px',
  name: '14%',
  address: '14%',
  homePhone: '11%',
  cellPhone: '11%',
  fax: '9%',
  email: '16%',
  action: '130px'
};

/** Attach shared width when staff layout is active (practice-scoped lists). */
export function staffCol(col, widthKey, useStaffLayout) {
  if (!useStaffLayout) return col;
  const width = STAFF_LIST_WIDTHS[widthKey];
  return width ? { ...col, width } : col;
}
